import LinkIcon from '@mui/icons-material/Link';
import DialogActions from '@mui/material/DialogActions';
import { useEffect, useState } from 'react';
import { Button, useTranslate } from 'react-admin';
import { useContentLangContext } from 'utils/providers/ContentLangProvider';
import { useMultiSelectionContext } from '../../../providers/MultiSelectionProvider';
import { Search, SearchIconWrapper, StyledInputBase } from '../../common/Search';
import LinkInputModalDialog from './LinkInputModalDialog';
import { useLinkInputContext } from './LinkInputProvider';
import { HandleSelectClick } from "./types";

interface LinkInputModalDialogContentProps {
    handleSelectClick: HandleSelectClick,
    handleCloseClick: () => void,
}

const LinkInputModalInputDialogContent = ({ handleSelectClick, handleCloseClick }: LinkInputModalDialogContentProps) => {
    const translate = useTranslate();
    const { selection, clearSelection } = useMultiSelectionContext();
    const handleClearClick = () => { clearSelection(); }
    const linkContext = useLinkInputContext();
    const { link } = linkContext;
    const { lang } = useContentLangContext();
    const [url, setUrl] = useState<string>('');

    const onSelectClick = () => {
        handleSelectClick(selection, lang, url);
    }

    useEffect(() => {
        // console.log(lang, link, selection);
        if (link && link.buildUrl) {
            setUrl(link.buildUrl(lang, linkContext, selection));
        }
    }, [lang, link, selection, linkContext]);

    return (
        <>
            <LinkInputModalDialog />
            <DialogActions>
                <Search style={{ flex: 1, backgroundColor: 'lightgray' }}>
                    <SearchIconWrapper><LinkIcon /></SearchIconWrapper>
                    <StyledInputBase
                        placeholder="Selected URL"
                        inputProps={{ style: { flex: 1 } }}
                        value={url}
                        onFocus={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            e.target.select();
                            document.execCommand('copy');
                            // e.target.blur();
                        }}
                        sx={{ flex: 1, }}
                    />
                </Search>
                <Button onClick={onSelectClick} label={translate("ra.action.confirm")} disabled={0 === selection.length} />
                <Button onClick={handleClearClick} label={translate("ra.action.clear_input_value")} disabled={0 === selection.length} />
                <Button onClick={handleCloseClick} label={translate("ra.action.close")} />
            </DialogActions>
        </>
    )
}

export default LinkInputModalInputDialogContent;